import { View, ViewModel } from "binder";
import { makeArray } from "jquery";
import { SelectorBaseViewModel } from "../selectorBase/selectorBase-viewModel";

export class GenderSelector extends SelectorBaseViewModel<gender>{
    public static MaleId : string = 'male';
    public static FemaleId : string = 'female';
    protected loadData(): Promise<gender[]> {
        let result : gender[] = [];
        let male = new gender(this);
        male.id = GenderSelector.MaleId;
        male.title = 'مرد';
        male.value = true;

        let female = new gender(this);
        female.id = GenderSelector.FemaleId;
        female.title = 'زن';
        female.value = false;

        result.push(male);
        result.push(female);
        return Promise.resolve(result);
    }

    getSelectedValue():boolean{
        return this.selectedItem?.value;
    }
    
}

export class gender extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set value(v: boolean) { this._value = v; } public get value(): boolean { return this._value;} private _value: boolean;

}